module.exports = __webpack_public_path__ + "img/x2_en_2025_04_25@2x.46779bc2.png";